import { useRouter } from 'next/router';
import { useMemo } from 'react';

import {
  ROUTE_TO_SIDEBAR_CONTENT,
  type SidebarPanelPinnedContent,
} from '@/atoms/sidebarPanelAtoms';
import { useIsNewSessionListEnabled } from '@/features/flags';

/**
 * Derives which sidebar content is "selected" based on the current route.
 * This maps to the nav-item selection logic:
 * - '/scribe/session/*' -> 'sessions' (unless new session list is enabled)
 * - '/scribe/chat/*' -> 'evidence'
 * - All other routes -> null (no sidebar content for this route)
 */
export function useSelectedSidebarContent(): SidebarPanelPinnedContent | null {
  const router = useRouter();
  const isNewSessionListEnabled = useIsNewSessionListEnabled();

  return useMemo(() => {
    for (const { pathPrefix, content } of ROUTE_TO_SIDEBAR_CONTENT) {
      if (isNewSessionListEnabled && content === 'sessions') continue;
      if (router.asPath.startsWith(pathPrefix)) {
        return content;
      }
    }
    return null;
  }, [router.asPath, isNewSessionListEnabled]);
}
